if (!customElements.get('mm-trust-bar')) {
  customElements.define('mm-trust-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('[data-trust-open]').forEach(link => {
        const dialog = this.querySelector(`[id="${link.dataset.trustOpen}"]`);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        link.setAttribute('aria-haspopup', 'dialog');
        link.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.returnFocus = link;
          dialog.showModal();
        });
        dialog.querySelector('.mm-trust__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => this.returnFocus?.focus({ preventScroll: true }));
      });
    }
  });
}
